@use '~/vendor/cxy/scss/styles/index.scss' as cxy;

$avatar-size-s: 40px;
$avatar-size-m-mobile: 40px;
$avatar-size-m-desktop: 48px;
$avatar-size-l-mobile: 56px;
$avatar-size-l-desktop: 120px;

.profile {
  display: flex;
  align-items: center;

  .image {
    padding: 0;
    box-shadow: none;

    img {
      height: 100%;
      object-fit: cover;
    }
  }

  .name {
    font-size: var(--cxy-fontSize-m);
    font-weight: var(--cxy-fontWeight-bold);
    line-height: var(--cxy-lineHeight-xxs);
  }

  .description,
  .link,
  .description p,
  .link p {
    font-size: var(--cxy-fontSize-xs);
    font-weight: var(--cxy-fontWeight-semiBold);
    line-height: var(--cxy-lineHeight-xxs);

    @include cxy.screen-size('desktop') {
      font-size: var(--cxy-fontSize-s);
    }
  }

  .name,
  .description {
    color: var(--cxy-color-text-default-body);
  }

  .name,
  .description,
  .link,
  .description p,
  .link p {
    margin: 0;
  }
}

.layout-column {
  gap: var(--cxy-spacing-xsm);
}

.layout-row {
  gap: var(--cxy-spacing-3);

  .details {
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: space-between;
  }
}

.size-s {
  .image {
    height: $avatar-size-s;
    width: $avatar-size-s;
  }
}

.size-m {
  .image {
    height: $avatar-size-m-mobile;
    width: $avatar-size-m-mobile;

    @include cxy.screen-size('desktop') {
      height: $avatar-size-m-desktop;
      width: $avatar-size-m-desktop;
    }
  }
}

.size-l {
  .image {
    height: $avatar-size-l-mobile;
    width: $avatar-size-l-mobile;

    @include cxy.screen-size('desktop') {
      height: $avatar-size-l-desktop;
      width: $avatar-size-l-desktop;
    }
  }

  .name {
    font-size: var(--cxy-fontSize-l);
    font-weight: var(--cxy-fontWeight-bold);
    line-height: var(--cxy-lineHeight-xxs);

    @include cxy.screen-size('desktop') {
      font-size: 32px;
      line-height: var(--cxy-lineHeight-l);
    }
  }

  .description,
  .link {
    font-size: var(--cxy-fontSize-s);
    font-weight: var(--cxy-fontWeight-normal);
    line-height: var(--cxy-lineHeight-xxs);

    @include cxy.screen-size('desktop') {
      font-size: 24px;
      font-weight: var(--cxy-fontWeight-semiBold);
      line-height: var(--cxy-lineHeight-l);
    }
  }
}
